import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

import type { ListingFiltersVariant } from '../../types';

export const Wrapper = styled(Box)<{ variant: ListingFiltersVariant }>`
  ${({ theme, variant }) =>
    variant === 'defaultInverted' &&
    css`
      color: ${theme.colors.white};
    `}
`;
